import React, { useState } from 'react';
import { Stethoscope } from 'lucide-react';
import MiniConsultModal from './MiniConsultModal';

const MiniConsultButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setIsModalOpen(true)}
        className="fixed bottom-6 right-6 z-[250] bg-gradient-to-br from-[#01A9B4] to-[#006A71] text-white p-4 md:p-5 rounded-full shadow-2xl hover:scale-110 transform transition-all duration-300 hover:shadow-[0_0_30px_rgba(1,169,180,0.6)] group"
        aria-label="Start Mini Consult NOW"
        data-floating-corner="right"
        data-testid="mini-consult-fab"
      >
        <div className="relative">
          {/* Icon */}
          <Stethoscope className="w-7 h-7 md:w-8 md:h-8" />
          
          {/* Pulse Animation */}
          <span className="absolute inset-0 rounded-full bg-[#01A9B4] animate-ping opacity-75"></span>
        </div>
        
        {/* Tooltip */}
        <div className="absolute bottom-full right-0 mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          <div className="bg-[#006A71] text-white px-4 py-2 rounded-lg shadow-xl whitespace-nowrap text-sm font-semibold">
            Mini Consult NOW
            <div className="absolute bottom-0 right-6 transform translate-y-1/2 rotate-45 w-3 h-3 bg-[#006A71]"></div>
          </div>
        </div>
      </button>
      
      {/* Modal */}
      <MiniConsultModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default MiniConsultButton;
